
/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  locale: string,
  params: {
    filter?: {
      [key: string]: any
    },
    limit: number,
    page: number,
    sort?: string
  }
};

/**
 * Export `paginationLimit` constant.
 */

export const paginationLimit = 24;

/**
 * Export `fetchCollections`.
 */

export async function fetchCollections({ locale, params }: Query) {
  const endpoint = getApiEndpoint('getCollections');

  if (!params.page) {
    return;
  }

  try {
    const currentPage = params?.page ?? 1;
    const { data } = await request.get(endpoint, {
      headers: acceptLanguageHeader(locale),
      params
    });

    return {
      data: data?.data,
      nextPage: +currentPage + 1,
      total: data?.total
    };
  } catch (error) {
    handleRequestError(error);
  }
}
